export default __webpack_public_path__ + "static/media/d0fc3afe192d3ea729a41fcacf138ec3.png";